import { cn } from "@/lib/utils";

const Input = ({ ref, className, type, onChange, allowFloat = false, ...props }) => {
  const handleChange = (e) => {
    let value = e.target.value;

    if (type === "number") {
      if (allowFloat) {
        // Allow float with max 2 decimal places
        if (!/^\d*\.?\d{0,2}$/.test(value)) return;
      } else {
        // Only allow up to 5-digit integers
        if (!/^\d{0,5}$/.test(value)) return;

        value = parseInt(value, 10) || 0;
      }

      const modifiedEvent = {
        ...e,
        target: {
          ...e.target,
          value: value.toString(),
        },
      };

      onChange?.(modifiedEvent);
    } else {
      onChange?.(e);
    }
  };

  return (
    <input
      type={type}
      step={type === "number" ? (allowFloat ? "0.01" : "1") : undefined}
      maxLength={type === "number" && !allowFloat ? 5 : undefined}
      className={cn(
        "bg-background flex h-9 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-950 shadow-xs shadow-black/5 transition-shadow placeholder:text-gray-500 focus-visible:border-blue-400 focus-visible:ring-3 focus-visible:ring-blue-400/50 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50",
        type === "search" &&
        "[&::-webkit-search-cancel-button]:appearance-none [&::-webkit-search-decoration]:appearance-none [&::-webkit-search-results-button]:appearance-none [&::-webkit-search-results-decoration]:appearance-none",
        type === "file" &&
        "p-0 pr-3 text-gray-500/70 italic file:me-3 file:h-full file:border-0 file:border-r file:border-solid file:border-gray-200 file:bg-transparent file:px-3 file:text-sm file:font-medium file:text-gray-950 file:not-italic",
        className
      )}
      ref={ref}
      onChange={handleChange}
      {...props}
    />
  );
};

Input.displayName = "Input";

export { Input };
